// import React, { useState } from "react";
// import axios from "axios";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faUpload } from '@fortawesome/free-solid-svg-icons';

// import { SERVER_ORIGIN, validation } from "../../utilities/constants";
// import Spinloader from "./Spinloader";

// import css from "../../css/admin/users-page.module.css";
// import toast from "react-hot-toast";

// const SchoolUpload = ({ onSuccess,emId }) => {
//     const [fileUploaded, setFileUploaded] = useState(false);
//     const [excelData, setExcelData] = useState(null);
//     const [correctFormat, setCorrectFormat] = useState(false);
//     const [loader, setLoader] = useState(false);

//     function handleFileRetrieve(e) {
//         setFileUploaded(true);
//         setExcelData(e.target.files?.[0]);
//     }

//     function handleFileUpload() {
//         if (!excelData) {
//             toast.error("Please select an Excel file");
//             return;
//         }

//         const formData = new FormData();
//         const file = excelData;
//         formData.append("document_file", file);
//   // ✅ Pass selected EM ID if provided (for non-EM users)
//         if (emId) {
//             formData.append("emId", emId);
//         }
//         setLoader(true);
//         setCorrectFormat(false);

//         axios.post(`${SERVER_ORIGIN}/api/em/auth/institute/upload-school`, formData, {
//             headers: {
//                 "auth-token": sessionStorage.getItem("token"),
//             },
//         })
//             .then((response) => {
//                 setCorrectFormat(true);
//                 setLoader(false);
//                 setFileUploaded(false);
//                 toast.success(response.data.statusText || "Schools uploaded successfully");
//                 if (onSuccess) {
//                     onSuccess();
//                 }
//                 // Reset file input
//                 setExcelData(null);
//                 const fileInput = document.getElementById("schoolInputTag");
//                 if (fileInput) {
//                     fileInput.value = "";
//                 }
//             })
//             .catch((error) => {
//                 console.log(error.response);
//                 const errorMessage = error.response?.data?.statusText || error.response?.data?.message || "Failed to upload schools";
//                 toast.error(errorMessage);
//                 setExcelData(null);
//                 setFileUploaded(false);
//                 setLoader(false);
//                 setCorrectFormat(false);
//             });
//     }

//     return (
//         <div className={css.fileDiv}>
//             <div className={css.innerFileDiv}>
//                 <label
//                     htmlFor="schoolInputTag"
//                     className={`${css.fileUploadBtn} commonBtn`}>
//                     <FontAwesomeIcon icon={faUpload} style={{ color: "#ffffff", marginRight: "5px" }} /> 
//                     <span>Select Excel File</span>
//                     <input
//                         id="schoolInputTag"
//                         type="file"
//                         onChange={handleFileRetrieve}
//                         accept=".xlsx, .xls"
//                         className={css.fileInput}
//                     />
//                 </label>
//             </div>
//             <div className={css.innerFileDiv}>
//                 <div className={css.innerFileDiv}>
//                     {loader && <Spinloader />}
//                     {fileUploaded && excelData ? (
//                         <h3 className={css.fileUploaded}>
//                             Excel data retrieved successfully. Press the 'Upload'
//                             button to upload the file.
//                         </h3>
//                     ) : (
//                         correctFormat && (
//                             <h3 className={css.fileUploaded}>
//                                 The data has been successfully uploaded.
//                             </h3>
//                         )
//                     )}
//                 </div>
//                 {excelData && (
//                     <button
//                         onClick={handleFileUpload}
//                         className={`${css.fileUploadBtn} commonBtn`}
//                         disabled={loader}
//                     >
//                         Upload
//                     </button>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default SchoolUpload;
import React, { useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { SERVER_ORIGIN } from "../../utilities/constants";
import Spinloader from "./Spinloader";
import css from "../../css/admin/users-page.module.css";
import toast from "react-hot-toast";

const SchoolUpload = ({ onSuccess, emId, children }) => {  // ✅ Added emId prop
    const [fileUploaded, setFileUploaded] = useState(false);
    const [excelData, setExcelData] = useState(null);
    const [loader, setLoader] = useState(false);

    // function handleFileRetrieve(e) {
    //     setFileUploaded(true);
    //     setExcelData(e.target.files?.[0]);
    // }
    function handleFileRetrieve(e) {
        const file = e.target.files?.[0];
        console.log("File selected in SchoolUpload:", file?.name, file?.size);
        setFileUploaded(true);
        setExcelData(file);
    }

    function handleFileUpload() {
        if (!excelData) {
            toast.error("Please select an Excel file");
            return;
        }


        const formData = new FormData();
        formData.append("document_file", excelData);

        if (emId) {
            formData.append("emId", emId);
        }

        console.log("Sending file:", excelData.name, excelData.type, excelData.size);

        setLoader(true);

        axios.post(`${SERVER_ORIGIN}/api/em/auth/institute/upload-school`, formData, {
            headers: {
                "auth-token": sessionStorage.getItem("token"),
            },
        })
            .then((response) => {
                setLoader(false);
                setFileUploaded(false);

                const { statusText, message, imported = 0, skipped = 0, skippedRows = [] } = response.data;

                // ── Success / Partial Success ───────────────────────────────────────
                if (imported > 0) {
                    toast.success(`${imported} school(s) imported successfully!`);

                    if (skipped > 0 && skippedRows.length > 0) {
                        const skippedDetails = skippedRows
                            .map((item) => `Row ${item.row}: ${item.reason} (${item.email || item.phone})`)
                            .join("\n");

                        toast(
                            `Warning: ${skipped} row(s) skipped:\n${skippedDetails}`,
                            {
                                icon: "⚠️",
                                duration: 12000,
                                style: {
                                    whiteSpace: "pre-line",
                                    maxWidth: "500px",
                                },
                            }
                        );
                    }
                }
                // ── Nothing imported (all skipped) ──────────────────────────────────
                else {
                    let errorMsg = message || "No valid schools could be imported.";

                    if (skippedRows.length > 0) {
                        const skippedDetails = skippedRows
                            .map((item) => `Row ${item.row}: ${item.reason} (${item.email || item.phone})`)
                            .join("\n");

                        errorMsg += `\n\nSkipped rows:\n${skippedDetails}`;
                    }

                    toast.error(errorMsg, {
                        duration: 12000,
                        style: {
                            whiteSpace: "pre-line",
                            maxWidth: "600px",
                        },
                    });
                }

                if (onSuccess) onSuccess();

                // Reset
                setExcelData(null);
                const fileInput = document.getElementById("schoolInputTag");
                if (fileInput) fileInput.value = "";
            })
            .catch((error) => {
                console.error("Upload error:", error);
                const errData = error.response?.data;
                let msg = errData?.message || "Failed to upload schools";

                if (errData?.statusText?.includes("Invalid Excel format")) {
                    msg = `${errData.message}\n\nPlease download the sample template and follow the exact column names.`;
                } else if (errData?.skippedRows?.length > 0) {
                    const details = errData.skippedRows
                        .map((r) => `Row ${r.row}: ${r.reason} (${r.email || r.phone})`)
                        .join("\n");
                    msg += `\n\n${details}`;
                }

                toast.error(msg, {
                    duration: 10000,
                    style: { whiteSpace: "pre-line" },
                });

                setLoader(false);
                setFileUploaded(false);
                setExcelData(null);
            });

        // axios.post(`${SERVER_ORIGIN}/api/em/auth/institute/upload-school`, formData, {
        //     headers: {
        //         "auth-token": sessionStorage.getItem("token"),
        //     },
        // })
        //     .then((response) => {
        //         setLoader(false);
        //         setFileUploaded(false);
        //         toast.success(response.data.statusText || "Schools uploaded successfully");
        //         if (onSuccess) onSuccess();
        //         setExcelData(null);
        //         const fileInput = document.getElementById("schoolInputTag");
        //         if (fileInput) fileInput.value = "";
        //     })
        //     .catch((error) => {
        //         const errorMessage = error.response?.data?.statusText || error.response?.data?.message || "Failed to upload schools";
        //         toast.error(errorMessage);
        //         setLoader(false);
        //         setFileUploaded(false);
        //         setExcelData(null);
        //     });
    }

    // ✅ Render children as trigger button (for modal)
    return children ? (
        children({ handleFileRetrieve, handleFileUpload, fileUploaded: !!excelData, isUploading: loader })
    ) : (
        // Original non-modal version (backward compatible)
        <div className={css.fileDiv}>
            <div className={css.innerFileDiv}>
                <label htmlFor="schoolInputTag" className={`${css.fileUploadBtn} commonBtn`}>
                    <FontAwesomeIcon icon={faUpload} style={{ color: "#ffffff", marginRight: "5px" }} />
                    <span>Select Excel File</span>
                    <input
                        id="schoolInputTag"
                        type="file"
                        onChange={handleFileRetrieve}
                        accept=".xlsx, .xls"
                        className={css.fileInput}
                    />
                </label>
            </div>
            <div className={css.innerFileDiv}>
                <div className={css.innerFileDiv}>
                    {loader && <Spinloader />}
                    {fileUploaded && excelData ? (
                        <h3 className={css.fileUploaded}>Excel data retrieved successfully. Press 'Upload' to upload.</h3>
                    ) : null}
                </div>
                {excelData && (
                    <button onClick={handleFileUpload} className={`${css.fileUploadBtn} commonBtn`} disabled={loader}>
                        Upload
                    </button>
                )}
            </div>
        </div>
    );
};

export default SchoolUpload;